import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ReactEcharts from "echarts-for-react";

const age_groups = ["<20", "20-29", "30-39", "40-49", "50-59", "60-69", ">=70"]

const AgeAndGenderGraph = (props) => {
    const { t, i18n } = useTranslation('common');
    const { data, title } = props;

    const option = useMemo(() => {
        if (!data || !data.length) return;

        const option = {
            angleAxis: {
                type: 'category',
                data: age_groups,
            },
            radiusAxis: {
                type: 'value',
                axisLabel: { show: false },
                axisTick: { show: false },
                axisLine: { show: false },
            },
            polar: {
                radius: [40, '75%']
            },
            dataset: {
                dimensions: ['age_group', 'female', 'male', 'other'],
                source: data
            },
            encode: {
                angle: 'age_group',
                radius: 'female',
            },
            legend: {
                formatter: (name) => t(name)
            },
            tooltip: {
                position: function (point, params, dom, rect, size) {
                    return [(size.viewSize[0] - size.contentSize[0]) / 2, (size.viewSize[1] - size.contentSize[1]) / 2]
                },
                formatter: ({ seriesName, value }) => {
                    return `<strong>${value[seriesName]}</strong><br/><span class="cdb-agegender-tooltip">${t(seriesName)}</span>`
                },
                transitionDuration: 0,
                hideDelay: 0,
                borderWidth: 0,
                padding: 0,
                textStyle: { fontSize: 15 },
                extraCssText: 'line-height: 1; box-shadow: none; text-align: center; border-radius: 50%',
            },
            series: [
                {
                    name: 'female',
                    type: 'bar',
                    coordinateSystem: 'polar',
                    stack: 'a',
                    itemStyle: { color: "#B4375D" },
                },
                {
                    name: 'male',
                    type: 'bar',
                    coordinateSystem: 'polar',
                    stack: 'a',
                    itemStyle: { color: "#00A4E0" }
                },
                {
                    name: 'other',
                    type: 'bar',
                    coordinateSystem: 'polar',
                    stack: 'a',
                    itemStyle: { color: "#F0C829" }
                }
            ]
        };

        return option;
    }, [data, i18n.language])

    return (
        <div className="dashboardView-card cdb-agegender dashboard-graph-card" >
            <p className="dashboardView-card-title">{title}</p>

            {
                option
                    ? <ReactEcharts
                        option={option}
                        style={{ height: '100%' }}
                    />
                    : <p>N/D</p>
            }
        </div>
    );
}

export default AgeAndGenderGraph